import { createFileRoute } from '@tanstack/react-router'
import { Result } from 'antd'
import z from 'zod'

import { useLocaleName } from '@/stores/setting.store.ts'

export const Route = createFileRoute('/auth/success')({
  component: RouteComponent,
  validateSearch: z.object({
    success_type: z.enum([
      'register_success',
      'reset_password_success',
      'forget_password_success',
      'email_change_success',
    ]),
  }),
})

function RouteComponent() {
  const locale = useLocaleName()
  const message = messages[locale]
  const search = Route.useSearch()

  return <Result status="success" title={message[search.success_type]} />
}

const messages = {
  'zh-CN': {
    register_success: '注册成功',
    reset_password_success: '密码重置成功',
    forget_password_success: '重置链接已发送，请查收邮件',
    email_change_success: '邮箱变更成功',
  },
  'en-GB': {
    register_success: 'Registration successful',
    reset_password_success: 'Password reset successful',
    forget_password_success: 'Reset link sent. Please check your email',
    email_change_success: 'Email change confirmed',
  },
  'cy-GB': {
    register_success: "Cofrestru'n llwyddiannus",
    reset_password_success: 'Cynewidpwd llwyddiannus',
    forget_password_success: 'Anfonwyd dolen ailosod. Gwiriwch eich e-bost',
    email_change_success: 'Cadarnhawyd newid e-bost',
  },
}
